import { TrackingStatus } from "@megaron/fulfillment-contracts";

export const packageWeightLimitKg = 25;

const environmentTemplate = process.env["NX_PUBLIC_ENVIRONMENT_TEMPLATE"];

export const isProduction = (): boolean => {
  if (environmentTemplate === "production") return true;
  if (environmentTemplate === "development") return false;
  const localConfig = typeof localStorage !== "undefined" ? localStorage.getItem("config") : null;
  if (localConfig) {
    try {
      const config = JSON.parse(localConfig) as { urlTemplate?: string };
      return config.urlTemplate === "PROD";
    } catch {
      return process.env["NODE_ENV"] === "production";
    }
  }
  return process.env["NODE_ENV"] === "production";
};

const getShopifyStoreName = () => (isProduction() ? "megaron-eu" : "megaron-sandbox");

const extractShopifyOrderId = (idString: string) => {
  const match = idString.match(/\/(\d+)$/);
  return match ? match[1] : idString.replace(/\D/g, "") || idString;
};

export const getShopifyOrderUrl = (orderId: string) => {
  const store = getShopifyStoreName();
  const numericId = extractShopifyOrderId(orderId);
  return `https://admin.shopify.com/store/${store}/orders/${numericId}`;
};

export const trackingStatusesBlockingSchedule: readonly TrackingStatus[] = [
  "stored_by_sender",
  "dispatched_by_sender",
  "collected_from_sender",
  "adopted_at_source_branch",
  "sent_from_source_branch",
  "adopted_at_sorting_center",
  "sent_from_sorting_center",
  "adopted_at_target_branch",
  "out_for_delivery",
  "out_for_delivery_to_address",
  "ready_to_pickup",
  "pickup_reminder_sent",
  "pickup_time_expired",
  "undelivered",
  "returned_to_sender",
  "delivered",
  "canceled",
  "claimed",
];
